<template>
  <div v-show="lastId !== '-1'">
    <!-- 展示框 -->
    <div class="title_state" id="chatBox">
      <div class="title">{{ info.name }}</div>
      
      <div v-for="infos in INFO.info" :key="infos.id">
        <div v-if="infos.userId == MyId" style="width:635px; height: auto; display: flex; float: right;
          flex-direction: row-reverse;
          justify-content: flex-start;
          background-color: white;" 
          ref="cchat">
          
          <div v-show="INFO.lens" style="">
            <img :src="infos.userPhoto" alt="" width="40px" height="40px" style="border-radius: 50%; float: right;">
            <pre class="ThePreContent">{{infos.message}}<!-- <button @click="del">点我删除</button> --></pre>
          </div>
        </div>
        <div v-else style="width:635px; height: auto; display: flex; float: right;
          justify-content: flex-start;
          background-color: white;" 
          ref="cchat">
          <div v-show="INFO.lens" style="">
            <pre class="ThePreContent">{{infos.message}}<!-- <button @click="del">点我删除</button> --></pre>
            <img :src="infos.userPhoto" alt="" width="40px" height="40px" style="border-radius: 50%; float: right;">
          </div>
        </div>
      </div>
      

    </div>

    <hr>
    <!-- 打字框 -->
    <div style="width: 650px; height: 100px;" v-on:keyup.enter="DianEnter">
      <textarea style="
        white-space: pre-wrap;
        border: none; 
        resize: none;
        outline:none;
        min-width: 650px; max-width: 650px; min-height: 100px; max-height: 100px; 
        resize: none; font-size:15px" v-model="INFO.textarea"
        id="myTextarea"
        type="text"
      >
      </textarea>
    </div>
    <!-- <button @click="transMessage">测试websocket</button> -->
    <div style="display: flex; flex-direction: row-reverse;">
      <button style="width: 100px; height: 30px;" @click="DianEnter($event)">发送</button>
    </div>
    
  </div>
</template>

<script>
    import Url from '@/constant/Url';
    import $ from 'jquery'
    import { nanoid } from 'nanoid';
    export default {
      name:'Chat',
      props:['info'],
      data() {
        return {
          MyId:'', // 用户自己的id
          socket:null, // websocket连接
          INFO:{
            textarea: '',/* 输入的内容 */
            info:[],
            lens:0,
            chatBox:null,
          },

          lastId:'-1',
          lastPhoto:'',
        }
      },
      mounted() {
        if (this.$store.state.me.token !== "") {
          this.CreateWebSocket()
          this.MyId = this.$store.state.me.id
        }
        else {
          const t = setInterval(() => {
            if (this.$store.state.me.token !== "") {
              console.log("我开始hh协议了")
              this.CreateWebSocket()
              this.MyId = this.$store.state.me.id
              clearInterval(t); // 清除定时器
              console.log("我停止了")
            }
          }, 100);
        }
      },
      beforeDestroy() {
        this.socket.close()
      },
      methods:{
        ReadFriendMessage() {
          const vue = this
          const store = this.$store

          $.ajax({
            url: Url.rFriendMessageUrl,
            type:'post',
            data: {
              userId: store.state.me.id,
              otherId: vue.lastId,
            },
            headers: {
              Authorization: "Bearer " + store.state.me.token,
            },
            success(resp) {
              if (resp.error_message === "success") { // 说明收到消息了
                vue.INFO.info = JSON.parse(resp.list)
                console.log(vue.INFO.info)
                vue.INFO.lens = vue.INFO.info.length

                vue.$nextTick(()=>{ /* 滚动条自动跟踪到最底部 */
                  chatBox.scrollTop = chatBox.scrollHeight;
                })
              }
            }
          })
        },
        transMessage() { // 发信息
          console.log("lastId == ", this.lastId)
          this.socket.send(
            JSON.stringify({
              event: "send_message",
              userId: this.lastId,
              content: this.INFO.textarea,
            })
          )
        },
        CreateWebSocket() {     
          this.socket = new WebSocket(`wss://app6132.acapp.acwing.com.cn/chatSocket/${this.$store.state.me.token}/`)

          this.socket.onopen = () => {
            console.log("connected!")
          }

          this.socket.onmessage = message => {
            const data = JSON.parse(message.data)
            console.log("data", data)
            console.log("对面发来的消息 = ", data.message);

            if (data.otherId !== this.lastId) {
              return ;
            }
            /* 先把消息放到msgs里面*/
            this.INFO.info.push({
              message:data.message, 
              id:nanoid(), 
              otherId: this.MyId, 
              otherPhoto: this.$store.state.me.photo,
              userId: this.lastId,
              userPhoto: this.lastPhoto,
            })
            this.INFO.lens = this.INFO.info.length
            this.$nextTick(()=>{ /* 滚动条自动跟踪到最底部 */
              chatBox.scrollTop = chatBox.scrollHeight;
            })
          }

          this.socket.onclose = () => {
            console.log("disconnected!");
          }
        },
        DeleteWebSocket() {
          this.socket.close()
        },
        changeLastId() {
          this.lastId = this.info.id
        },
        del() {
          this.INFO.textarea = ''
          this.INFO.info.length = 0 /* 去除历史记录 */
          this.INFO.lens = 0 /* 让页面清空 */
        },
        DianEnter(e) {         
          if (e.keyCode === 13 && e.ctrlKey) {
              console.log("我要加换行咯")
              // Ctrl+Enter，换行
              this.INFO.textarea += '\n';
          }
          else {
            if (this.INFO.textarea.trim() === "") {
              return ;
            }

            this.socket.send(
              JSON.stringify({
                event: "send_message",
                otherId: this.lastId,
                otherPhoto: this.lastPhoto,
                content: this.INFO.textarea,
              })
            )

            /* 先把消息放到msgs里面*/
            this.INFO.info.push({
              message:this.INFO.textarea, 
              id:nanoid(), 
              userId: this.MyId, 
              userPhoto: this.$store.state.me.photo,
              otherId: this.lastId,
              otherPhoto: this.lastPhoto,
            })
            this.INFO.lens = this.INFO.info.length
            this.$nextTick(()=>{ /* 滚动条自动跟踪到最底部 */
              chatBox.scrollTop = chatBox.scrollHeight;
            })

            this.INFO.textarea = '' /* 清空输入框 */
          }
        },
      },
    }
</script >

<style scoped>
.title {
  width:100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  color: pink;
  text-align: center;
  
}
.ThePreContent{
  font-family:"微软雅黑";
  float: right;
  margin: 6px 3px 3px 3px;
  padding: 4px;
  max-width: 300px; 
  width: fit-content;
  height: fit-content;
  min-width: 20px;
  min-height: 35px; 
  background-color: #12B7F5; 
  height: auto; 
  font-size:18px; 
  border-radius: 4px; 
  word-break: break-all; 
  overflow: hidden;
  white-space: pre-wrap;
}
/* 第一条是展示框样式 */
.title_state {
  width: 650px; 
  height: 260px; 
  overflow: auto; 
  display: flex; 
  flex-direction:column;
}
/* 下面都是滚动条样式 */
.title_state::-webkit-scrollbar {
  width:5px;

  height:10px;
    /* height: 4px; */
    /* border-radius: 4px;s */
    /* overflow-y: scroll; */
}

.title_state::-webkit-scrollbar-thumb {
  background-color:pink;

  height:50px;

  outline-offset:-2px;

  outline:2px solid #fff;

  -webkit-border-radius:4px;

  border: 2px solid #fff;

  
}

.title_state::-webkit-scrollbar-thumb:hover {
  background-color:#999999;

  height:50px;

  -webkit-border-radius:4px;
}

.title_state::-webkit-scrollbar-piece {
  background-color:#fff;

  -webkit-border-radius:0;
}
</style>